<template>
  <div>
    <section>
      <div class="btmPattern">
        <div class="freight-big-pro-book title white">
          OUR PRESENTATION CENTRE<br />
          IS NOW OPEN
        </div>
        <br />
        <div class="contactInfoWrap">
          <div class="contactInfo px-4">
            <div class="acumin-pro-wide-light text white">
              <a href="https://maps.app.goo.gl/xYsHaRhTHvGLZ3RP8" target="_blank">4 Nicort Rd, Wasaga Beach L9Z 0N4</a>
            </div>
            <div class="acumin-pro-wide-light text white">
              <a href="tel:705-429-1013">CALL: 705.429.1013</a>
            </div>
            <br />
            <div class="acumin-pro-wide-light text white">MONDAY-THURSDAY: 11 am - 5 pm</div>
            <div class="acumin-pro-wide-light text white">FRIDAY: CLOSED</div>
            <div class="acumin-pro-wide-light text white">SATURDAY, SUNDAY & HOLIDAYS: 11 am - 5 pm</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
#presentation {
  background-color: $m-blue;
  .btmPattern {
    background-image: url("/img/HERO_Image.jpg");
    background-size: cover;
    background-position: center;
    min-height: 20vh;
    padding: 4rem 0px;
    text-align: center;
    .title {
      font-size: 2rem;
      line-height: 110%;
    }

    .contactInfoWrap {
      display: flex;
      flex-direction: row;
      justify-content: center;
      .contactInfo {
        .text {
          font-size: 14px;
          line-height: 145%;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
